import { CHANGE_STATE_TREE_SETTINGS } from '../constants/actionTypes.js';
export function stateTreeSettings(state = {
    sortAlphabetically: false,
    disableCollection: false,
}, action) {
    if (action.type === CHANGE_STATE_TREE_SETTINGS) {
        return {
            sortAlphabetically: action.sortAlphabetically,
            disableCollection: action.disableCollection,
        };
    }
    return state;
}
